<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div id="pageItemList">
    <v-layout row class="align-center layout px-4 pt-4 app--page-header">
      <div class="page-header-left">
        <h3 class="pr-3">
          <v-icon>bug_report</v-icon>
          {{ $t("issue") }} #{{ issue.rma }}
        </h3>
      </div>
      <v-breadcrumbs divider="-" :items="breadcrumbs"> </v-breadcrumbs>
    </v-layout>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex md8 offset-md2>
          <v-card>
            <v-list two-line>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">train</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ issue.vehicle.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("vehicle") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">calendar_today</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ issue.occurrence_date | moment("LL") }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("occurrenceDate") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">place</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $t("occurrencePlaces." + issue.occurrence_place) }}
                    <span v-if="issue.occurrence_place === 'OTHER'">
                      ({{ issue.occurrence_place_custom }})
                    </span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("occurrencePlace") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider inset></v-divider>

              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">settings</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ issue.item }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("issueItem") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action></v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ issue.item_additional_info }}
                    <span
                      v-if="!issue.item_additional_info"
                      class="font-italic"
                    >
                      {{ $t("lack") }}
                    </span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("issueItemAdditionalInfo") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider inset></v-divider>

              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">person_pin</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ issue.contact_person }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("contactPerson") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action></v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ issue.automatic | booleanText }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("generatedAutomatically") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider inset></v-divider>

              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">turned_in_not</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $t("issueStatus." + issue.status) }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("status") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon ripple @click="loadStatusHistory" v-on="on">
                        <v-icon>history</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("showIssueStatusHistory") }}</span>
                  </v-tooltip>
                </v-list-tile-action>
              </v-list-tile>

              <span v-if="issueStatusHistory.length">
                <v-list-tile
                  v-for="(item, index) in issueStatusHistory"
                  :key="index"
                >
                  <v-list-tile-action></v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      $t("issueStatus." + item.status)
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      item.updated_at | moment("LLL")
                    }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>{{
                      item.updated_by.name
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </span>

              <v-divider inset></v-divider>

              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">access_time</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ issue.created_at | moment("LLL") }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("creationDate") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">person_add</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ issue.created_by.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("creator") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md8 offset-md2>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("serviceReports") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">build</v-icon>
            </v-toolbar>

            <v-list>
              <v-list-tile
                v-for="(serviceReport, key) in issue.service_reports"
                :key="key"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    #{{ serviceReport.rma }}
                  </v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn
                    icon
                    ripple
                    :to="{
                      name: 'ServiceReportShow',
                      params: { id: serviceReport.id }
                    }"
                  >
                    <v-icon color="primary">details</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md8 offset-md2>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("files") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">attach_file</v-icon>
            </v-toolbar>

            <v-list>
              <v-list-tile
                v-for="(file, key) in issue.files"
                :key="key"
                :href="getFileDownloadUrl(file)"
                target="_blank"
              >
                <v-list-tile-content>
                  <v-list-tile>{{ file.original_name }}</v-list-tile>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-list-tile-action-text>{{
                    file.size | prettyBytes
                  }}</v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_ISSUE, FETCH_ISSUE_STATUS_HISTORY } from "@/store/actions.type";
import JwtService from "../../common/jwt.service";

export default {
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t("issues"),
          to: { name: "Issues" },
          exact: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["issue", "issueStatusHistory", "issueIsLoading"])
  },
  methods: {
    loadStatusHistory() {
      this.$store
        .dispatch(FETCH_ISSUE_STATUS_HISTORY, this.issue.id)
        .then(() => {});
    },
    getFileDownloadUrl(file) {
      return (
        process.env.VUE_APP_API_HOST +
        file.download_url +
        "?bearer=" +
        JwtService.getToken()
      );
    }
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(FETCH_ISSUE, to.params.id)]).then(() => {
      next();
    });
  }
};
</script>

<style scoped></style>
